module.exports = __webpack_public_path__ + "images/imagetitle-err.dc23c0ad.png";